<template>
  <div>
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Administradores"></no-habilitado>
    <app-error v-if="error" :errorMensaje="errorMensaje"></app-error>
    <h1 style="margin-top:100px; margin-left:50px">Administrar puntajes</h1>
    <section
      v-if="(puntajes.length>0)"
      style=" background-color: #ececec; padding-top: 50px; padding-bottom: 30px; margin-left: 20px; margin-right: 20px;"
    >
      <h3 v-if="userLogged.profile != 'ADMINISTRADOR'">Puntaje</h3>

      <div class="container">
        <div class="row" style="justify-content: center">
          <div v-for="(puntaje,index) in puntajes" :puntaje="puntaje" v-bind:key="index">
            <div class="card categoria" @click="seleccionarPuntaje(puntaje)">
              <div class="card-body">
                <h3 class="texto-car-categoria">{{ puntaje.evento }} | {{ puntaje.puntaje }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <b-modal
      ref="modificar-modal"
      hide-footer
      :title="'Modificar puntaje de ' + puntajeSeleccionado.evento"
    >
      <div class="d-block">
        <div class="form-group">
          <label>Puntaje</label>
          <input class="form-control" v-model="puntajeSeleccionado.puntaje" />
        </div>

        <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
      </div>
      <b-button
        class="mt-3"
        variant="primary"
        block
        @click="modificarPuntaje(puntajeSeleccionado)"
      >Modificar</b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";
import appError from "../shared/Error";

export default {
  name: "app",
  data() {
    return {
      habilitado: false,
      error: false,
      puntajeSeleccionado: {},
      errorMessage: "",
      puntajes: []
    };
  },
  methods: {
    buscarPuntajes() {
      fetch(this.pathAPI + "puntaje.php?usuario=" + this.userLogged.user)
        .then(response => response.json())
        .then(data => {
          this.puntajes = data;
          console.log(this.puntajes);
        });
    },
    seleccionarPuntaje(puntaje) {
      this.puntajeSeleccionado = puntaje;
      this.$refs["modificar-modal"].show();
    },
    modificarPuntaje(puntaje) {
      var bodyApi;
      (bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&evento=" +
        puntaje.evento +
        "&puntaje=" +
        puntaje.puntaje),
        fetch(this.pathAPI + "puntaje.php?" + bodyApi, {
          method: "PUT",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        })
          .then(() => {
            this.$refs["modificar-modal"].hide();
          })
          .catch(() => {
            console.log("error");
          });
    }
  },
  computed: {
    ...mapGetters(["userLogged", "pathAPI"])
  },
  components: {
    Loader: Loader,
    NoHabilitado: NoHabilitado,
    appError: appError
  },

  mounted: function() {
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.buscarPuntajes();
      this.habilitado = true;
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/admin/AdminPuntaje.vue